import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, FormSelect } from "react-bootstrap";
import { Skeleton, Divider, Typography } from "antd";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import {
  //setting
  provinceAddress,
  districtAddress,
  subdistrictAddress,
} from "../../redux/actions";

const inputStyle = {
  width: "100%",
  height: "41px",
  borderRadius: "8px",
};

const validStyle = {
  minHeight: "20px",
  marginTop: "5px",
  marginLeft: "10px",
};

const DisableinputStyle = {
  backgroundColor: "#e9ecef", // สีเทาเหมือน input ที่ disabled
  color: "#6c757d", // สีตัวอักษรอ่อนลง
  cursor: "not-allowed",
};

const OrganizationForm = ({
  organizationInfoData,
  setOrganizationInfoData,
  sameAddress,
  setSameAddress,
  lang,
  selectProvinceOption,
  selectDistrictOption,
  selectSubDistrictOption,
  //checkfield
  organizationErrors,
  handleBlur,
  touchedFields,
}) => {
  const dispatch = useDispatch();

  console.log("OrganizationForm Start...");
  //selected ID
  const [selectProvince, setSelectProvince] = useState("");
  const [selectDistrict, setSelectDistrict] = useState("");
  const [selectSubDistrict, setSelectSubDistrict] = useState("");
  const [selectPostal_code, setSelectPostal_code] = useState("");

  console.log(
    "selectProvince org:",
    selectProvince,
    "selectDistrict org:",
    selectDistrict,
    "selectSubDistrict org:",
    selectSubDistrict,
    "selectPostal_code org:",
    selectPostal_code
  );

  useEffect(() => {
    if (organizationInfoData?.length > 0) {
      const organizationInfo = organizationInfoData[0]; // Directly use the first item

      setSelectProvince(Number(organizationInfo.org_province));
      setSelectDistrict(Number(organizationInfo.org_district));
      setSelectSubDistrict(Number(organizationInfo.org_subDistrict));
      setSelectPostal_code(Number(organizationInfo.org_postalCode));
    } else {
      console.log("No company info available");
    }
  }, []);

  useEffect(() => {
    // ดึงข้อมูล Province จาก API
    dispatch(provinceAddress({ lang: "both" }));
  }, []);

  useEffect(() => {
    if (selectProvince) {
      // ดึงข้อมูล District เมื่อเลือก Province
      dispatch(districtAddress({ lang: "both", id: selectProvince }));
    }
  }, [selectProvince, lang]); // โหลดใหม่เมื่อ selectProvince หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectDistrict) {
      // ดึงข้อมูล Sub District เมื่อเลือก District
      dispatch(subdistrictAddress({ id: selectDistrict, lang: "both" }));
    }
  }, [selectDistrict, lang]); // โหลดใหม่เมื่อ selectDistrict หรือ lang เปลี่ยน

  useEffect(() => {
    if (selectSubDistrict && selectSubDistrictOption.length > 0) {
      const found = selectSubDistrictOption.find(
        (item) => item.value === Number(selectSubDistrict)
      );
      console.log("found:", found);
      if (found) {
        setSelectPostal_code(found.post_code || "N/A"); // ถ้าไม่มีค่า ให้ใช้ "N/A"
        handleInputChange("org_postalCode", 0, found.post_code);
      }
    }
  }, [selectSubDistrict]);

  //Handle input change
  const handleInputChange = (fieldName, index, value) => {
    setOrganizationInfoData((prevData) => {
      // Create a shallow copy of the array
      const updatedData = [...prevData];
      // Update the specific field for the targeted index
      updatedData[index] = {
        ...updatedData[index],
        [fieldName]: value,
      };
      return updatedData;
    });
  };

  const handleFileChange = (e, index) => {
    const file = e.target.files[0]; // ดึงไฟล์จาก input
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // แปลงไฟล์เป็น Base64
      reader.onload = () => {
        handleInputChange("org_logo", index, reader.result); // อัพเดท state
      };
      reader.onerror = (error) => {
        console.error("Error converting file to base64:", error);
      };
    }
  };

  return (
    <Container className="">
      {organizationInfoData.map((data, index) => (
        <Form key={index} className="p-4" style={{ color: "rgb(0, 0, 0)" }}>
          <Divider orientation="left">Organization Information</Divider>

          {/* Organization Name */}
          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Organization Name*</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter organization name"
                  style={inputStyle}
                  onChange={(e) =>
                    handleInputChange("organizationName", index, e.target.value)
                  }
                  value={data.organizationName || ""}
                  onBlur={() => handleBlur("organizationName")}
                  isInvalid={
                    touchedFields.organizationName &&
                    !!organizationErrors.organizationName
                  }
                  isValid={
                    touchedFields.organizationName &&
                    !organizationErrors.organizationName &&
                    !!data.organizationName
                  }
                />
                <div style={validStyle}>
                  {organizationErrors.organizationName &&
                    touchedFields.organizationName && (
                      <span className="text-danger">
                        {organizationErrors.organizationName}
                      </span>
                    )}
                </div>
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Organization Name* (English)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter organization english name"
                  style={inputStyle}
                  value={data.organizationNameEng}
                  onChange={(e) =>
                    handleInputChange(
                      "organizationNameEng",
                      index,
                      e.target.value
                    )
                  }
                  onBlur={() => handleBlur("organizationNameEng")}
                  isInvalid={
                    touchedFields.organizationNameEng &&
                    !!organizationErrors.organizationNameEng
                  }
                  isValid={
                    touchedFields.organizationNameEng &&
                    !organizationErrors.organizationNameEng &&
                    !!data.organizationNameEng
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {organizationErrors.organizationNameEng &&
                  touchedFields.organizationNameEng && (
                    <span className="text-danger">
                      {organizationErrors.organizationNameEng}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control
                  type="text"
                  maxLength={10}
                  placeholder="Enter phone number"
                  style={inputStyle}
                  value={data.org_phoneNumber}
                  onChange={(e) =>
                    handleInputChange("org_phoneNumber", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_phoneNumber")}
                  isInvalid={
                    touchedFields.org_phoneNumber &&
                    !!organizationErrors.org_phoneNumber
                  }
                  isValid={
                    touchedFields.org_phoneNumber &&
                    !organizationErrors.org_phoneNumber &&
                    !!data.org_phoneNumber
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {organizationErrors.org_phoneNumber &&
                  touchedFields.org_phoneNumber && (
                    <span className="text-danger">
                      {organizationErrors.org_phoneNumber}
                    </span>
                  )}
              </div>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Fax No.</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email address"
                  style={inputStyle}
                  value={data.org_faxNumber}
                  onChange={(e) =>
                    handleInputChange("org_faxNumber", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_faxNumber")}
                  isInvalid={
                    touchedFields.org_faxNumber &&
                    !!organizationErrors.org_faxNumber
                  }
                  isValid={
                    touchedFields.org_faxNumber &&
                    !organizationErrors.org_faxNumber &&
                    !!data.org_faxNumber
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {organizationErrors.org_faxNumber &&
                  touchedFields.org_faxNumber && (
                    <span className="text-danger">
                      {organizationErrors.org_faxNumber}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter email"
                  style={inputStyle}
                  value={data.org_email}
                  onChange={(e) =>
                    handleInputChange("org_email", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_email")}
                  isInvalid={
                    touchedFields.org_email && !!organizationErrors.org_email
                  }
                  isValid={
                    touchedFields.org_email &&
                    !organizationErrors.org_email &&
                    !!data.org_email
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {organizationErrors.org_email && touchedFields.org_email && (
                  <span className="text-danger">
                    {organizationErrors.org_email}
                  </span>
                )}
              </div>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Website</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter website"
                  style={inputStyle}
                  value={data.org_website}
                  onChange={(e) =>
                    handleInputChange("org_website", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_website")}
                  isInvalid={
                    touchedFields.org_website &&
                    !!organizationErrors.org_website
                  }
                  isValid={
                    touchedFields.org_website &&
                    !organizationErrors.org_website &&
                    !!data.org_website
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {organizationErrors.org_website &&
                  touchedFields.org_website && (
                    <span className="text-danger">
                      {organizationErrors.org_website}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          {/* Logo Upload */}
          <Form.Group controlId="formFile" className="mb-0">
            <Form.Label>Logo Upload</Form.Label>
            <Form.Control
              style={{ borderRadius: "8px" }}
              type="file"
              // onChange={(e) =>
              //   handleInputChange("org_logo", index, e.target.value)
              // }
              onChange={(e) => handleFileChange(e, index)}
            />
            <Form.Text className="text-muted">
              *Logo size: width 1280 px x height 720 px | less than 1 MB (File:
              *.png, *.jpg)
            </Form.Text>
          </Form.Group>
          <div style={validStyle}>
            {organizationErrors.org_logo && touchedFields.org_logo && (
              <span className="text-danger">{organizationErrors.org_logo}</span>
            )}
          </div>

          <Divider orientation="left">Organization Address</Divider>

          <Form.Group controlId="formSameAsOrgAddress" className="mb-0">
            <Form.Check
              type="checkbox"
              label="Same as Company Address"
              onChange={(e) => setSameAddress(e.target.checked)}
              checked={sameAddress}
            />
          </Form.Group>

          {/* Address Details */}
          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Organization Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address number"
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  disabled={sameAddress}
                  value={data.org_address}
                  onChange={(e) =>
                    handleInputChange("org_address", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_address")}
                  isInvalid={
                    !sameAddress &&
                    touchedFields.org_address &&
                    !!organizationErrors.org_address
                  }
                  isValid={
                    !sameAddress &&
                    touchedFields.org_address &&
                    !organizationErrors.org_address &&
                    !!data.org_address
                  }
                />
              </Form.Group>

              <div style={validStyle}>
                {!sameAddress &&
                  organizationErrors.org_address &&
                  touchedFields.org_address && (
                    <span className="text-danger">
                      {organizationErrors.org_address}
                    </span>
                  )}
              </div>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Organization Address2</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address number"
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  value={data.org_address2}
                  disabled={sameAddress}
                  onChange={(e) =>
                    handleInputChange("org_address2", index, e.target.value)
                  }
                  onBlur={() => handleBlur("org_address2")}
                  isInvalid={
                    !sameAddress &&
                    touchedFields.org_address2 &&
                    !!organizationErrors.org_address2
                  }
                  isValid={
                    !sameAddress &&
                    touchedFields.org_address2 &&
                    !organizationErrors.org_address2 &&
                    !!data.org_address2
                  }
                />
              </Form.Group>
              <div style={validStyle}>
                {!sameAddress &&
                  organizationErrors.org_address2 &&
                  touchedFields.org_address2 && (
                    <span className="text-danger">
                      {organizationErrors.org_address2}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          {/* <Row className="mb-0">
            <Col sm={6}></Col>
            <Col sm={6}></Col>
          </Row> */}

          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Province</Form.Label>
                <Form.Select
                  placeholder="Select Province"
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  disabled={sameAddress}
                  onChange={(e) => {
                    handleInputChange("org_province", index, e.target.value);
                    setSelectProvince(e.target.value);
                  }}
                  value={data.org_province || ""}
                  onBlur={() => handleBlur("org_province")}
                  isInvalid={
                    !sameAddress &&
                    touchedFields.org_province &&
                    !!organizationErrors.org_province
                  }
                  isValid={
                    !sameAddress &&
                    touchedFields.org_province &&
                    !organizationErrors.org_province &&
                    !!data.org_province
                  }
                >
                  <option style={{ zIndex: "1050" }}>
                    Please select province {/* แสดง label ตามภาษา */}
                  </option>
                  {selectProvinceOption &&
                    selectProvinceOption.map((item, index) => (
                      <option
                        key={index}
                        value={item.value}
                        style={{ zIndex: "1050" }}
                      >
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div style={validStyle}>
                {!sameAddress &&
                  organizationErrors.org_province &&
                  touchedFields.org_province && (
                    <span className="text-danger">
                      {organizationErrors.org_province}
                    </span>
                  )}{" "}
              </div>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>District</Form.Label>
                <Form.Select
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  disabled={sameAddress}
                  onChange={(e) => {
                    handleInputChange("org_district", index, e.target.value);
                    setSelectDistrict(e.target.value);
                  }}
                  value={data.org_district || ""}
                  onBlur={() => handleBlur("org_district")}
                  isInvalid={
                    !sameAddress && touchedFields.org_district && !!organizationErrors.org_district
                  }                  
                  isValid={
                    !sameAddress && touchedFields.org_district &&
                    !organizationErrors.org_district &&
                    !!data.org_district
                  }
                >
                  <option value="" disabled selected>
                    Please select province
                  </option>
                  {selectDistrictOption &&
                    selectDistrictOption.map((item, index) => (
                      <option key={index} value={item.value}>
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div style={validStyle}>
              {!sameAddress && organizationErrors.org_district && touchedFields.org_district &&  (
                    <span className="text-danger">
                      {organizationErrors.org_district}
                    </span>
                  )}
              </div>
            </Col>
          </Row>

          <Row className="mb-0">
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Sub District</Form.Label>
                <Form.Select
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  disabled={sameAddress}
                  onChange={(e) => {
                    handleInputChange("org_subDistrict", index, e.target.value);
                    setSelectSubDistrict(e.target.value);
                  }}
                  value={data.org_subDistrict || ""}

                  onBlur={() => handleBlur("org_subDistrict")}
                  isInvalid={
                    !sameAddress && touchedFields.org_subDistrict && !!organizationErrors.org_subDistrict
                  }                  
                  isValid={
                    !sameAddress && touchedFields.org_subDistrict &&
                    !organizationErrors.org_subDistrict &&
                    !!data.org_subDistrict
                  }
                >
                  <option value="" disabled selected>
                    Please select district
                  </option>
                  {selectSubDistrictOption &&
                    selectSubDistrictOption.map((item, index) => (
                      <option key={index} value={item.value}>
                        {lang === "en" ? item.label1 : item.label2}{" "}
                        {/* แสดง label ตามภาษา */}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
              <div style={validStyle}>
              {!sameAddress && organizationErrors.org_subDistrict && touchedFields.org_subDistrict &&  (
                    <span className="text-danger">
                      {organizationErrors.org_subDistrict}
                    </span>
                  )}
              </div>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Postal Code</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter postal code"
                  style={
                    sameAddress
                      ? { ...inputStyle, ...DisableinputStyle }
                      : inputStyle
                  }
                  disabled={true}
                  value={selectPostal_code || ""}
                />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      ))}
    </Container>
  );
};

// export default OrganizationForm;

const mapStateToProps = (state) => {
  console.log("Redux State:", state); // ตรวจสอบ state ทั้งหมด

  return {
    //Address
    selectProvinceOption: state.settings.selectProvince,
    selectDistrictOption: state.settings.selectDistrict,
    selectSubDistrictOption: state.settings.selectSubDistrict,
  };
};

const mapDispatchToProps = {
  //Address
  provinceAddress,
  districtAddress,
  subdistrictAddress,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationForm);
